module.exports = __webpack_public_path__ + "static/media/cooking.b9ccb58b.jpg";